// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1bYt4","signatureBlock":"Footer_signatureBlock__NLyQm","signature":"Footer_signature__1mEMW"};